import { configRepo, type ConfigType } from "@/repositories/configRepo";
import type { ExampleFilesConfig } from "@repo/types";
import { useObservable } from "@repo/ui/components/Base/hooks/useObservable";
import { map } from "rxjs";

export const useGetConfig = <T extends ConfigType>(type: T = "config" as T) => {
  return useObservable(() => configRepo.get(type), [type]);
};

export const useGetAppConfig = () => useGetConfig("config");

export const useGetOrganizationTypes = () => useGetConfig("organizationTypes");

export const useGetMeetingTypes = () => useGetConfig("meetingTypes");

export const useGetDocumentUploadTypes = () =>
  useGetConfig("documentUploadTypes");

export const useGetAgendaItemMetadata = () =>
  useGetConfig("agendaItemMetadata");

export const useGetTermsAndConditions = () =>
  useGetConfig("termsAndConditions");

export const useGetMotionTypes = () => useGetConfig("motionTypes");

export const useGetExampleFile = (file: keyof ExampleFilesConfig) => {
  return useObservable(
    () =>
      configRepo.get("exampleFiles").pipe(
        map((config) => {
          const { fileBits, fileName, fileType } = config[file];
          return new File([fileBits], fileName, { type: fileType });
        })
      ),
    [file]
  );
};

export const useGetUserImportExample = () =>
  useGetExampleFile("userImportExample");
